import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerRegistroUnicoIvaModalComponent } from './worker-registro-unico-iva-modal';

export const WorkerRegistroUnicoIvaModalModule: string = ng
    .module('worker-registro-unico-iva-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerRegistroUnicoIvaModalComponent', WorkerRegistroUnicoIvaModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-registro-unico-iva-modal/worker-registro-unico-iva-modal.module.ts